// extracted by mini-css-extract-plugin
export default {"cardContainer":"ProjectCard_cardContainer__UPtV8","cardContent":"ProjectCard_cardContent__jtwsO"};